export default __webpack_public_path__ + "static/media/06_photo.f6cc0880.jpg";